import React from "react";
import classNames from "classnames";
import { useMeet } from "util/useMeet";

import concat from "lodash/concat";
import take from "lodash/take";
import times from "lodash/times";

import { useDisplaySettings } from "./DisplaySettingsProvider";

import DisplayComponent from "./DisplayComponent";
import {
  getDivisionDoc,
  getLiftersInDivisionAndWeightClass,
  getScore,
  getTotal,
  sortLiftersByPlace,
} from "util/lifterHelper";
import { Lifter } from "types";
import round from "lodash/round";

const Standings = ({ id }: { id: string }) => {
  const meet = useMeet();
  const { standingsDivisionId, standingsWeightClassId, standingsCount } =
    useDisplaySettings();

  if (!meet) {
    return null;
  }

  const division = getDivisionDoc(standingsDivisionId, meet);
  const weightClass = division
    ? division.weightClasses[standingsWeightClassId]
    : null;

  const divisionLifters =
    division && weightClass
      ? getLiftersInDivisionAndWeightClass({
          meet,
          division,
          weightClass,
        })
      : [];

  const sortedLifters = division
    ? sortLiftersByPlace({
        lifters: divisionLifters,
        meet,
        division,
        forecasted: false,
      })
    : [];

  const padded = take(
    concat(
      sortedLifters,
      times(standingsCount, () => ({}) as Lifter),
    ),
    standingsCount,
  );

  return (
    <DisplayComponent style={{ top: 900, left: 0 }} id={id}>
      {() => {
        return (
          <div className="standings">
            <div className="stadings-heading">
              {division && weightClass ? (
                <>
                  {division.name}{" "}
                  {weightClass.name?.toLowerCase() === "all" ? (
                    ""
                  ) : (
                    <>
                      {weightClass.name} {meet.units}
                    </>
                  )}
                </>
              ) : (
                "Select a division and weight class"
              )}
            </div>
            {padded.map((lifter, index) => {
              const hasLifter = Boolean(lifter._id);
              const lifterName = hasLifter ? lifter.name || "" : "";
              const total =
                hasLifter && division
                  ? getTotal({
                      lifter,
                      division,
                      meet,
                      forecasted: false,
                    })
                  : 0;

              const score =
                hasLifter && division
                  ? round(
                      getScore({
                        lifter,
                        division,
                        meet,
                        forecasted: false,
                      }),
                      3,
                    )
                  : "";

              return (
                <div
                  className="standings-row"
                  key={lifter._id || `empty-${index}`}
                >
                  <div className="standings-place">
                    {total ? index + 1 : ""}
                  </div>
                  <div
                    className={classNames("standings-lifter", {
                      "long-name": lifterName.length > 18,
                      "really-long-name": lifterName.length > 21,
                    })}
                  >
                    {lifterName}
                  </div>

                  <div className="standings-score">
                    {lifterName ? score : ""}
                  </div>
                </div>
              );
            })}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default Standings;
